<template>
    <div class="" :style="{color:pageData[0].textColor,backgroundColor:pageData[0].backgroundColor}">
      <div class="header-notice" ref='noticeWarpper' >
        <!-- <i class="xx-icon icon-tongzhi" :style="{backgroundColor:pageData[0].backgroundColor}"></i> -->
        <i class="xx-icon icon-tongzhi" style="color:#f05b47;"></i>
        <span class="notice-title" style="color:#f05b47">公告</span>
        <em class="fgx">|</em>
        <div class="notice-text" ref='noticeContent'>
          <marquee v-if="pageData.length>1" style="height:30px; line-height:30px; margin-bottom:3px;" direction="up" scrolldelay="300">
            <span  class="notice-text-con" v-for="(item, index) in pageData" :key="index">{{item.content}}</span>
          </marquee>
          <span v-else  class="notice-text-con" v-for="(item, index) in pageData" :key="index">{{item.content}}</span>
        </div>
        <!-- <span style="display:inline-block;" class="notice-text" ref='noticeContent'>{{pageData.content}}</span> -->
      </div>
    </div>    
</template>

<script>
export default {
  props: {
    pageData: {
      type: Array,
      default: []
    }
  },
  mounted(){
    this.$nextTick(()=>{
      let bodyWidth =  parseFloat(window.getComputedStyle(this.$refs.noticeWarpper).width)
     let width =  parseFloat(window.getComputedStyle(this.$refs.noticeContent).width)
      let num = 0;
     if(width>bodyWidth-40){
       //滚动
       this.setIntervalTime = setInterval(()=>{
         num = num-1
         if(num<-width){
           num=bodyWidth
         }
          this.$refs.noticeContent.style.transform = 'translate(' + num + 'px)'
       },50)
     }
    })
  },
  methods: {},
  destroyed(){
    clearInterval(this.setIntervalTime)
  }
}
</script>

<style lang='scss' scoped>
.header-notice{
    width: 1200px;
    margin: 0 auto;
    height: 35px;
    line-height: 35px;
    .icon-tongzhi{
      // color: #f05b47;
      font-size: 14px;
      font-style: normal;
      display: block;
      float: left;
    }
    .notice-title{
      // color: #f05b47;
      font-size: 14px;
      display: block;
      float: left;
      margin-left: 5px;
    }
    .fgx{
      font-size: 14px;
      // color: #413838;
      margin: 0 10px;
      font-style: normal;
      display: block;
      float: left;
    }
    .notice-text{
      font-size: 14px;
      display: block;
      float: left;
      height: 35px;
      line-height: 35px;
      .notice-text-con{
        // word-break:break-all;
        // display:-webkit-box;
        // -webkit-line-clamp:1;
        // -webkit-box-orient:vertical;
        // overflow:hidden;
         overflow:hidden;
        text-overflow:ellipsis;
        white-space:nowrap
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/custompage/customComponent/notice.vue